import { cmApiUrl } from '@atc/cm-api-url';
import fetchJSON from '../../fetchers/utils/fetchJSON.js';
import getFetchOptions from '../../fetchers/utils/getFetchOptions.js';
const options = {
  circuitBreaker: {
    id: 'payoffQuote',
    timeout: 10000,
    fallback: {
      error: 'Circuit Breaker for /rest/retail/payoff is open'
    },
    errorFilter: error => error?.status === 401,
    allowWarmUp: true
  },
  retryOn: [401],
  retries: 1,
  retryDelay: 800
};
function getPayoffQuoteFetcher(path) {
  return {
    path: path + 'cars-for-sale' + cmApiUrl('/rest/retail/payoff'),
    // partnerOptOutList: Empty for now, but this is where partnerId's for partners who wish to opt out will go. Ex. ['OTX', 'FAD', 'AM3', ...]
    partnerOptOutList: [],
    async fetchAllPartners() {
      try {
        const result = await fetchJSON(`${this.path}/partners`, getFetchOptions(options));
        if (result && Array.isArray(result) && result.length) {
          return result.filter(partner => !this.partnerOptOutList.includes(partner?.partnerId));
        }
        return [];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching all partners: ', error);
        return {
          error: true,
          message: error
        };
      }
    },
    async fetchPartnerById(partnerId) {
      try {
        const data = await fetchJSON(`${this.path}/partners/id/${partnerId}`, getFetchOptions(options));
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching partner id: ', error);
        return {
          error: true,
          message: error
        };
      }
    },
    async fetchPayoffQuote(data) {
      try {
        const response = await fetchJSON(`${this.path}/quotes`, getFetchOptions({
          ...options,
          method: 'POST',
          data
        }));
        return response;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching payoff quote: ', error);
        return {
          error: true,
          message: error
        };
      }
    }
  };
}
export { getPayoffQuoteFetcher as default };
